import { FieldArray } from 'formik';

import { graphql } from '@e-socna/data-layer';

import { useAddressesFieldArrayRenderer } from './hooks/useFieldArrayRenderer.hook';
import type { Props } from './types/props.type';

export const ThirdPartyForm_AddressesStep_ThirdParty_Fragment = graphql(`
  fragment ThirdPartyForm_AddressesStep_ThirdParty_Fragment on ThirdParty {
    _id
    isInternal
    kind
    statusId
    addresses {
      ...AddressForm_Address_Fragment
    }
  }
`);

export const ThirdPartyAddressesFormStep = (props: Readonly<Props>) => {
  const { fieldArrayRender } = useAddressesFieldArrayRenderer(props);

  return <FieldArray name="addresses" render={fieldArrayRender} />;
};
